import React from 'react'
import useFetch from '../../utils/useFetch'
import Header from '../../utils/header'
import { DecodeHtml } from '../../utils/decodeHtml'

const ShortCourseDetailModal = ({ url }) => {
  const data = useFetch(url)
  const courseData = data?.properties
  const title = courseData?.overviewText
  const content = courseData?.contents?.markup
  return (
    <div className='max-w-[90vw] max-h-[90vh] overflow-y-auto p-4 lg:p-8 flex flex-col gap-5'>
      {!data ? (
        <div className='flex items-center justify-center h-full'>
          <div className='w-16 h-16 border-4 border-dashed rounded-full animate-spin border-gray-950'></div>
        </div>
      ) : data?.status == '404' ? (
        <div className='flex items-center justify-center h-full'>
          <p className='text-gray-500'>No Data Found</p>
        </div>
      ) : (
        <>
          <Header text={title} />
          {content && DecodeHtml({ html: content })}
        </>
      )}
    </div>
  )
}

export default ShortCourseDetailModal
